import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { useCallback } from 'react';

export const useActionMessageClicked = (
	onMessageClick: (e: React.MouseEvent<HTMLElement>) => void,
	interactionIdentifier: string,
): {
	handleClick: (e: React.MouseEvent<HTMLElement>) => void;
} => {
	const { messageClicked, messageDismissed } = useMessageEvent();
	const { onCtaActioned } = usePostOfficeUserInteractions();

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLElement>): void => {
			messageClicked().catch(() => {});
			void onCtaActioned({
				interactionIdentifier,
				additionalMetadata: {},
			});
			onMessageClick(e);

			// Dismiss Create Whiteboard and Create Page message instances after the user clicks on the action
			// This is so that if the user reloads the page, the message is not shown again.
			// Otherwise, there is a delay of 5 mins due to us using cached tap-sidecar with a 5-min TTL so the latest TAP trait info won't be retrieved till then
			if (
				interactionIdentifier.includes('CREATE_WHITEBOARD') ||
				interactionIdentifier.includes('CREATE_PAGE')
			) {
				messageDismissed().catch(() => {});
			}
		},
		[interactionIdentifier, messageClicked, messageDismissed, onCtaActioned, onMessageClick],
	);

	return { handleClick };
};
